// free-tools 统一下载入口 —— 所有"下真文件"的下载一律经 app 的 /download 页(承载广告 + 内部产品推荐)。
// 就一套,和转换器(下载 v3)完全一致,别再零散造轮子:
//   · 客户端产物(浏览器内 blob,如 QR/裁剪/缩放/翻转/拼图…)→ downloadBlob:/download 读 blob: URL 下载。
//   · 后端产物(已写入 R2,如视频/转换)→ downloadUrl:/download?direct=1 导航到 R2 公开 URL
//     (对象自带 Content-Disposition,不取 blob、不经 Nitro 代理、任意大小)。
// 非文件下载(文本/复制到剪贴板,如 base64/ascii/调色板)不走这里。
export function useFreeToolsDownload() {
  const userR2Base = (useRuntimeConfig().public.userR2Url || "").replace(/\/+$/, "");

  function openDownloadTab(params) {
    if (typeof window === "undefined") return;
    const qs = new URLSearchParams(params);
    qs.set("prev_route1", window.location.pathname);
    qs.set("prev_route1_title", (document.title || "Free Tools").split(/[—|]/)[0].trim());
    window.open("/download/?" + qs.toString(), "_blank");
  }

  // 客户端 blob → /download(isTemp:读 blob: URL 下载)。blob URL 生命周期归 /download 标签页,这里不 revoke。
  function downloadBlob(blob, filename) {
    if (!blob || typeof window === "undefined") return;
    openDownloadTab({ img_title: filename || "download", img_path: URL.createObjectURL(blob) });
  }

  // 后端 R2 产物 → /download?direct=1 导航到 R2 公开 URL(自带附件头,任意大小)。
  function downloadUrl(url, filename, size) {
    if (!url || typeof window === "undefined") return;
    const p = { img_title: filename || "download", img_path: url, direct: "1" };
    if (size) p.file_size = size;
    openDownloadTab(p);
  }

  // 后端异步 job 的结果对象公开 URL(与转换器一致:userR2Url + /free-tools/results/<jobId>)。
  const resultUrl = (jobId) => userR2Base + "/free-tools/results/" + encodeURIComponent(jobId);

  return { downloadBlob, downloadUrl, resultUrl, openDownloadTab };
}
